var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("CatNicknameDialogBase", {
    attrs: { "on-click-outside": _vm.onClickOutside },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", { staticClass: "dialog-header" }, [
              _c(
                "div",
                { staticClass: "cat-display" },
                [
                  _c("cat-icon", {
                    attrs: {
                      size: "large",
                      clickable: false,
                      "writer-type": _vm.assistantCat?.assistantCatType,
                    },
                  }),
                ],
                1
              ),
              _c("h2", { staticClass: "dialog-title" }, [
                _vm._v(_vm._s(_vm.$t("myPage.catNicknameConfirmDialog.title"))),
              ]),
              _c("p", { staticClass: "dialog-subtitle" }, [
                _vm._v(" " + _vm._s(_vm.dialogSubtitle) + " "),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("div", { staticClass: "dialog-footer" }, [
              _c(
                "button",
                { staticClass: "button cancel", on: { click: _vm.onClose } },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
              _c("div", { staticClass: "divider" }),
              _c(
                "button",
                { staticClass: "button primary", on: { click: _vm.onConfirm } },
                [_vm._v(_vm._s(_vm.$t("common.yes")))]
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }